import React from 'react';
import { FC, useState } from 'react';
import Slider from 'react-slick';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate from '@ui/SectionTitle/Title';
import { publicAssets } from '@utils/url.utils';
import { breakpoints } from '../../styles/theme';
import ContentWrapper from '../../ui/Content/Content';
import { CarouselWrapper, Client, ClientImage, Wrapper } from './Partners.elements';

interface PartnersProps {}

const PartnersTemplate: FC<PartnersProps> = () => {
    const { t } = useTranslation();
    const clients = [
        '/spp.jpg',
        '/stredoslovenska-distribucna.jpg',
        '/nafta.jpg',
        '/hyundai.jpg',
        '/antolin.jpg',
        '/continental.jpg',
        '/billa.jpg',
        '/uprsv.jpg',
        '/vub.jpg',
        '/mobis.jpg',
        '/idea-dss.jpg',
        '/eustream.jpg',
        '/dolvap.jpeg',
        '/kastiel-mojmirovce.jpeg',
    ];
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: breakpoints.sm,
                settings: { slidesToShow: 2, dots: true },
            },
            {
                breakpoint: breakpoints.md,
                settings: { slidesToShow: 3, dots: true },
            },
        ],
    };
    return (
        <ContentWrapper withPadding mobileSidePadding={20}>
            <Wrapper>
                <TitleTemplate isBlack>{t('customTraining.clients.title')}</TitleTemplate>
                <CarouselWrapper>
                    <Slider {...settings}>
                        {clients.map((client, index) => (
                            <Client key={index}>
                                <ClientImage src={publicAssets(client)} />
                            </Client>
                        ))}
                    </Slider>
                </CarouselWrapper>
            </Wrapper>
        </ContentWrapper>
    );
};
export default PartnersTemplate;
